import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { CustomFormControl, } from '../../../../StyledComponents';

export const Schema = Yup.object().shape({
    periodFrom: Yup.date()
        .typeError("Bitte einen gültigen Wert angeben")
        .required("Angabe ist erforderlich"),
});

export const PeriodSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Label style={{ margin: 0 }}>Wann soll dein Praktikum stattfinden:</Form.Label>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formPeriodFrom">
                    <Form.Label>Am/Von*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        type="date"
                        name="periodFrom"
                        value={values.periodFrom}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.periodFrom && !errors.periodFrom}
                        isInvalid={touched.periodFrom && errors.periodFrom}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.periodFrom}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} controlId="formPeriodTo">
                    <Form.Label>Bis</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        type="date"
                        name="periodTo"
                        value={values.periodTo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.periodTo && !errors.periodTo}
                        isInvalid={touched.periodTo && errors.periodTo}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.periodTo}
                    </Form.Control.Feedback>
                </Form.Group>
          </Row>
        </>
    );
};